import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DollarSign, Users, BarChart3, TrendingUp, Receipt } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';

const menuItems = [
  {
    id: 'centro-costos',
    title: 'Centro de Costos',
    description: 'Registra y distribuye gastos a nivel empresa, centro de lavado o cliente',
    icon: <DollarSign className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />,
    path: '/financiera/centro-costos',
    iconBg: 'bg-emerald-500/15',
    borderColor: 'hover:border-emerald-500/50',
    color: 'bg-emerald-500/10',
  },
  {
    id: 'nomina',
    title: 'Nómina',
    description: 'Liquidación y gestión de pagos al personal',
    icon: <Users className="h-8 w-8 text-blue-600 dark:text-blue-400" />,
    path: '/liquidacion-personal',
    iconBg: 'bg-blue-500/15',
    borderColor: 'hover:border-blue-500/50',
    color: 'bg-blue-500/10',
  },
  {
    id: 'liquidacion-clientes',
    title: 'Liquidación de Clientes',
    description: 'Genera liquidaciones a partir de las entregas confirmadas con kardex y precios editables',
    icon: <Receipt className="h-8 w-8 text-amber-600 dark:text-amber-400" />,
    path: '/financiera/liquidacion-clientes',
    iconBg: 'bg-amber-500/15',
    borderColor: 'hover:border-amber-500/50',
    color: 'bg-amber-500/10',
  },
  {
    id: 'reportes',
    title: 'Reportes',
    description: 'Análisis y resumen de gastos por nivel y categoría',
    icon: <BarChart3 className="h-8 w-8 text-violet-600 dark:text-violet-400" />,
    path: '/financiera/reportes',
    iconBg: 'bg-violet-500/15',
    borderColor: 'hover:border-violet-500/50',
    color: 'bg-violet-500/10',
  },
];

const FinancieroDashboard = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="p-4 md:p-4 lg:p-4"
    >
      <Card>
        <CardHeader className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-b border-border/50">
          <div className="flex items-center gap-4">
            <div className="bg-emerald-500/15 p-2.5 rounded-lg">
              <TrendingUp className="h-7 w-7 text-emerald-600 dark:text-emerald-400" />
            </div>
            <div>
              <CardTitle className="text-2xl">Módulo Financiero</CardTitle>
              <CardDescription className="mt-1">
                Gestión de costos, nómina e indicadores financieros de la compañía
              </CardDescription>
            </div>
          </div>
        </CardHeader>

        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {menuItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.08 }}
                onClick={() => navigate(item.path)}
                className={`${item.color} p-6 rounded-lg border border-border shadow-sm transition-all duration-200 cursor-pointer hover:shadow-md ${item.borderColor}`}
              >
                <div className="flex flex-col items-center text-center">
                  <div className={`p-2.5 rounded-lg ${item.iconBg}`}>
                    {item.icon}
                  </div>
                  <h3 className="text-base font-semibold mt-3">{item.title}</h3>
                  <p className="text-xs text-muted-foreground mt-1.5 line-clamp-2">{item.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default FinancieroDashboard;
